import { render } from "./RibaRecheckout.vue?vue&type=template&id=712841a8"
import script from "./RibaRecheckout.vue?vue&type=script&lang=js"
export * from "./RibaRecheckout.vue?vue&type=script&lang=js"
script.render = render

export default script